import React, { useEffect, useState } from "react";
import classes from "./CategoryBlogs.module.css";
import moment from "moment-timezone";
import { motion } from "framer-motion";

const CategoryBlogs = ({ data, onClickHandler, slice }) => {
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (event, data) => {
    event.stopPropagation();
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      onClickHandler(data?.id);
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <>
      <motion.div
        className={classes.category_blogs}
        drag="x"
        dragConstraints={{
          top: 0,
          left: slice
            ? -1800
            : data.length == 1
            ? 0
            : data.length > 5
            ? data.length * -220
            : data.length * -150,
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {data?.length > 0 &&
          data.slice(0, 8)?.map((dataItem, idx) => {
            return (
              <motion.div
                layout
                className={classes.blog}
                key={idx}
                onMouseDown={handleMouseDown}
                onMouseUp={(event) => handleMouseUp(event, dataItem)}
                onMouseMove={handleMouseMove}
              >
                {dataItem?.blog_image ? (
                  <div className={classes.blog_image_container}>
                    <img
                      src={dataItem?.blog_image}
                      alt="blog"
                      className={classes.blog_image}
                    />
                  </div>
                ) : (
                  <div className={classes.blog_image_container}>
                    <img
                      src="/assets/images/no-image.jpg"
                      alt="news"
                      className={classes.blog_image}
                    />
                  </div>
                )}

                <div className={classes.blog_content}>
                  <p className={`${classes.blog_title}`}>
                    {dataItem?.blog_title}
                  </p>
                  <p className={`${classes.blog_snippet}`}>
                    {dataItem?.blog_description
                      ?.split("\n")
                      .map((desc, index) => (
                        <React.Fragment key={index}>
                          {desc}
                          <br />
                        </React.Fragment>
                      ))}
                  </p>
                </div>

                <div className={classes.actions}>
                  <div className={classes.blog_details}>
                    <p className={classes.uploaded_by}>
                      ~ {dataItem?.user_name}
                    </p>
                    <p className={classes.date_time}>
                      {moment(dataItem?.datetime).fromNow()}
                    </p>
                  </div>
                  <button type="button" className={classes.link}>
                    <i
                      className={`pi pi-arrow-right ${classes.arrow_link}`}
                    ></i>
                  </button>
                </div>
              </motion.div>
            );
          })}
      </motion.div>
    </>
  );
};

export default CategoryBlogs;
